import Vue from 'vue';
import App from '../app.vue';
import router from '../router.js';
import store from '../store/store.js';
import {i18n, loadLanguageAsync} from '../startup/i18n.js';
import * as ion from 'ion-sound';
// import movable from 'v-movable';
// Vue.use(movable);
import '../startup/dayjs.js';// https://day.js.org/ru/ альтернатива moment.js которая весит всего 2кб
import '../startup/plugins.js'; // Инициализация всех подключаемях модулей и расширение компонента vue, глобальными методами
import '../startup/injections.js'; // Расширение некоторых сущностей новыми методами
import '../startup/filters.js';// Кастомные фильтры
import '../startup/directives.js';// Кастомные директивы
import '../startup/baseComponents.js';// Добавление базовых компонентов (которые начинаются на Base*) в глобвльную область видимости
import '../../../stylesheets/refactoring/common.scss';// Некоторые базовые глобальные стили

import {ROUTE_PATHS} from '../const.js';
const langPromise = loadLanguageAsync();// Загрузка и установка локализации. Промис, делается асинхронно

document.addEventListener('DOMContentLoaded', () => {
  langPromise.then(()=>{
    window.vm = new Vue({
      router,
      i18n,
      store,
      ion,
      data: {
        bus: new Vue({}),
        /* Это глобальный евент эмиттер.
                В любой точке приложения можно отослать глобальное событие,
                например this.$bus.$emit('updateArbs', someData)
                и словить в любой точке
                this.$bus.$on('updateArbs', (someData)=> {})
                Нужно в хуке beforeDestroy отписываться от события
                this.$bus.$off('updateArbs', (someData)=> {})*/
        routesList: ROUTE_PATHS,
      },
      render: (h) => h(App),
    }).$mount('#root');
  });
});
